import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {EmployeePerformanceReportData} from "./employee-performance-report.data";

@Injectable()
export class EmployeePerformanceReportModel extends ReportModel<EmployeePerformanceReportData> {
    constructor(injector: Injector) {
        super(injector, EmployeePerformanceReportData);
    }
}
